const getLineChartYStepValue = (data) => {
  if (!data || data.length === 0) return 5;

  const max = Math.max(...data.map((el) => Number(el)));

  if (max >= 2000) return 1000;
  if (max >= 500) return 100;
  if (max >= 100) return 50;
  if (max >= 50) return 10;
  return 5;
};

export default getLineChartYStepValue;
